import { findElementInShadowDom } from './utils/render.js';

async function main() {
  const dropdown = findElementInShadowDom('select#dropnav');

  if (dropdown) {
    dropdown?.addEventListener('change', (e) => {
      const select = /** @type {HTMLSelectElement} */ (e.target);
      let getSelectedValue = select.value;
      const offset = Number(select.selectedOptions[0]?.dataset.offset) || 0;
      // window.location.href = getSelectedValue;
      const targetElement = document.querySelector(getSelectedValue);
      if (targetElement) {
        // Get the top position of the target element relative to the document
        const targetPosition =
          targetElement.getBoundingClientRect().top + window.scrollY;

        // Scroll to the target position minus the offset
        window.scrollTo({
          top: targetPosition + offset,
          behavior: 'smooth',
        });
      }
    });
  }
}

main().catch(console.error);
